import {LOCATION_CHANGE} from 'react-router-redux';

import RESOURCE from '~/modules/resources/types';
import resourceId from '~/misc/resourceId';
import create from '~/misc/create';

const initialState = {
  byDOT: {},
};

const loadURLRegexp = /(?:\/brokers\/|\/my-company\/)(.*[^\/])$/;

const matchBroker = (url) => {
  const matched = url.match(loadURLRegexp);
  return matched && resourceId('broker', {DOT: matched[1]});
};

const loadsResource = (DOT) => resourceId('queriedLoads', {query: {dots: {eq: [DOT]}, limit: 200, length_allow_null: true}});
const saferwatchResource = (DOT) => resourceId('saferwatch', {DOT});

const reducer = (state, action, fullState) => {
  switch (action.type) {
    case LOCATION_CHANGE: {
      const oldPath = fullState.routing.pathname;
      const newPath = action.payload.pathname;

      const oldItem = matchBroker(oldPath);
      const newItem = matchBroker(newPath);

      const byDOT = state.byDOT;

      if (!newItem && !oldItem) {
        return null;
      }

      const newBroker = newItem && {
        loadsIdentity: loadsResource(newItem.props.DOT),
        saferwatchIdentity: saferwatchResource(newItem.props.DOT),
      };

      const oldBroker = oldItem && byDOT[oldItem.props.DOT];

      const changes = newItem
        ? {
          ...byDOT,
          [newItem.props.DOT]: newBroker,
        }
        : byDOT;

      return {
        byDOT: changes,
        actionsQueue: [
          oldItem && create(RESOURCE.RESOURCE_NOT_NEEDED, {
            name: 'queriedLoads',
            need: oldBroker.loadsIdentity,
            needy: oldItem,
          }),
          oldItem && create(RESOURCE.RESOURCE_NOT_NEEDED, {
            name: 'saferwatch',
            need: oldBroker.saferwatchIdentity,
            needy: oldItem,
          }),

          newItem && create(RESOURCE.RESOURCE_NEEDED, {
            name: 'queriedLoads',
            need: newBroker.loadsIdentity,
            needy: newItem,
          }),
          newItem && create(RESOURCE.RESOURCE_NEEDED, {
            name: 'saferwatch',
            need: newBroker.saferwatchIdentity,
            needy: newItem,
          }),
        ].filter(item => item),
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/brokers/reducer.js